import { DateTime } from 'luxon';

function parseDate(date, { zone, format }) {
  const opts = zone ? { zone } : {};
  if (DateTime.isDateTime(date)) return date;
  if (format) return DateTime.fromFormat(date, format, opts);
  return DateTime.fromISO(date, opts);
}

/**
 * Normalizes a date into a day-start `DateTime` for a DatePicker `minDate`/`maxDate`.
 * Returns `undefined` for empty or unparseable input so the picker stays unbounded
 * rather than disabling every date.
 *
 * @param {string | DateTime | null | undefined} date ISO string, `yyyy-MM-dd` string, or DateTime
 * @param {{ zone?: string, format?: string }} [options] `zone` for the org timezone; `format` when
 *   the input is a non-ISO pattern such as `yyyy-MM-dd`
 * @returns {DateTime | undefined}
 */
export function toDateBound(date, options = {}) {
  if (!date) return undefined;

  const parsed = parseDate(date, options);
  return parsed.isValid ? parsed.startOf('day') : undefined;
}
